export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11389.68273d77.jpg";